/**
 * Opmaak van bedragen en data voor de ING-ingang op favotrip.de, in de-DE. Geen
 * rekenwerk en geen afronding: een heel bedrag (de ING-prijzen) zonder
 * decimalen, elk ander bedrag met de centen die de backend stuurt.
 *
 * Een eigen bestand zonder woordenboeken, zodat ook de boekstraat in de browser
 * (IngDeBoekstraat.jsx) precies dezelfde opmaak gebruikt als de collectie;
 * ing-de-weergave.js geeft deze functies ongewijzigd door.
 */

const EUR_HEEL = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});
const EUR_CENTEN = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** "1.149 €" voor een heel bedrag, "2.917,43 €" voor een bedrag met centen. */
export function formatEurDe(bedrag) {
  return Number.isInteger(bedrag) ? EUR_HEEL.format(bedrag) : EUR_CENTEN.format(bedrag);
}

const DATUM_DE = new Intl.DateTimeFormat("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "UTC" });
const MEETDATUM_DE = new Intl.DateTimeFormat("de-DE", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  timeZone: "Europe/Berlin",
});

/** Een kalenderdatum "2026-10-24" als "24.10.2026" (zonder tijdzoneschuif). */
export function formatDatumDe(isoDatum) {
  return DATUM_DE.format(new Date(`${isoDatum}T00:00:00Z`));
}

/** Het meetmoment (ISO met tijd) als datum in Duitse tijd: "24.10.2026". */
export function formatMeetdatumDe(iso) {
  return MEETDATUM_DE.format(new Date(iso));
}
